export const getLocalizedText = (value: any, language: string = 'en') => {
  if (typeof value === 'string') {
    return value
  }
  if (value && typeof value === 'object') {
    if (value[language]) {
      return value[language]
    }
    if (value.en) {
      return value.en
    }
    const firstKey = Object.keys(value)[0]
    if (firstKey) {
      return value[firstKey]
    }
  }
  return ''
}

